import { SET_CV_LINK, SET_NEW_LANGUAGE } from "./constants";

export const setNewLanguage = (lang) => ({type: SET_NEW_LANGUAGE, lang});
export const setCvLink = (lang) => ({type: SET_CV_LINK, lang});